var _excluded = ["delay", "isCompleting", "onComplete", "className", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useTransition } from 'react-spring';
import { SpinnerSvg } from './components/SpinnerSvg.js';
import { SpinnerOuter, SpinnerContainer } from './components/styledContainer.js';
import { SpinnerSize } from './types.js';
import { jsx } from '@emotion/react/jsx-runtime';

function Spinner(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 100 : _ref$delay,
      _ref$isCompleting = _ref.isCompleting,
      isCompleting = _ref$isCompleting === void 0 ? false : _ref$isCompleting,
      _ref$onComplete = _ref.onComplete,
      onComplete = _ref$onComplete === void 0 ? function () {} : _ref$onComplete,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SpinnerSize.Regular : _ref$size,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var transition = useTransition(!isCompleting, {
    key: isCompleting.toString(),
    from: {
      opacity: 0,
      transform: 'rotate(50deg)'
    },
    enter: {
      opacity: 1,
      transform: 'rotate(230deg)',
      delay: delay
    },
    leave: {
      opacity: 0,
      transform: 'rotate(510deg)'
    },
    onRest: function onRest(result) {
      if (result.finished) onComplete();
    }
  });
  return jsx(SpinnerOuter, _objectSpread(_objectSpread({}, restProps), {}, {
    className: className,
    size: size,
    children: transition(function (styles, item, _ref2) {
      var _styles$opacity;

      var key = _ref2.key;
      return item && jsx(SpinnerContainer, {
        size: size,
        style: {
          opacity: (_styles$opacity = styles.opacity) === null || _styles$opacity === void 0 ? void 0 : _styles$opacity.to({
            range: !item ? [0, 0.45, 1] : [0, 1],
            output: !item ? [0, 0, 1] : [0, 1]
          }),
          transform: styles.transform
        },
        children: jsx(SpinnerSvg, {
          focusable: "false",
          viewBox: "0 0 100 100",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("circle", {
            cx: "50",
            cy: "50",
            r: "45"
          })
        })
      }, key);
    })
  }));
}

export { Spinner };
